import React from "react";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import { useTranslation } from "react-i18next"; // Import useTranslation
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // إضافة useNavigate إذا لم يكن موجوداً (للـ onClick في الروابط)

const Footer = () => {
  const { t } = useTranslation(); // Initialize translation
  const navigate = useNavigate(); // للتنقل الداخلي
  const currentYear = new Date().getFullYear();

  const { storeInfo } = useSelector((state) => state.general);

  // معلومات الاتصال الجديدة
  const contactInfo = {
    phone: "07772235662",
    email: "aleefieiq@gmail.com",
    facebook:
      "https://www.facebook.com/people/Aleefie-%D8%A3%D9%84%D9%8A%D9%81%D9%8A/61563597517036/?mibextid=LQQJ4d",
    instagram:
      "https://www.instagram.com/aleefie_iq/?igsh=MXgzcXM2eDB0cHVnag%3D%3D&utm_source=qr#",
  };

  const quickLinks = [
    {
      name: t("quickLinks.shoppingCart"),
      path: "/shopping-cart",
      icon: "ShoppingCart",
    },
    { name: t("quickLinks.wishlist"), path: "/wishlist", icon: "Heart" },
    { name: t("quickLinks.myAccount"), path: "/login", icon: "User   " },
  ];

  const footerSections = [
    {
      title: t("footerSections.shop"),
      links: [
        {
          name: t("footerSections.links.electronics"),
          path: "/product-listing?category=electronics",
        },
        {
          name: t("footerSections.links.fashion"),
          path: "/product-listing?category=clothing",
        },
        {
          name: t("footerSections.links.beauty"),
          path: "/product-listing?category=beauty",
        },
        {
          name: t("footerSections.links.homeGarden"),
          path: "/product-listing?category=home",
        },
        {
          name: t("footerSections.links.sports"),
          path: "/product-listing?category=sports",
        },
        {
          name: t("footerSections.links.books"),
          path: "/product-listing?category=books",
        },
      ],
    },
    {
      title: t("footerSections.customerService"),
      links: [
        { name: t("footerSections.links.contactUs"), path: "/contact" },
        { name: t("footerSections.links.helpCenter"), path: "/help" },
        { name: t("footerSections.links.trackOrder"), path: "/track-order" },
        { name: t("footerSections.links.returnsExchanges"), path: "/returns" },
        { name: t("footerSections.links.shippingInfo"), path: "/shipping" },
        { name: t("footerSections.links.sizeGuide"), path: "/size-guide" },
      ],
    },
    {
      title: t("footerSections.company"),
      links: [
        { name: t("footerSections.links.aboutUs"), path: "/about" },
        { name: t("footerSections.links.careers"), path: "/careers" },
        { name: t("footerSections.links.press"), path: "/press" },
        {
          name: t("footerSections.links.investorRelations"),
          path: "/investors",
        },
        {
          name: t("footerSections.links.sustainability"),
          path: "/sustainability",
        },
        { name: t("footerSections.links.blog"), path: "/blog" },
      ],
    },
    {
      title: t("footerSections.legal"),
      links: [
        { name: t("footerSections.links.privacyPolicy"), path: "/privacy" },
        { name: t("footerSections.links.termsOfService"), path: "/terms" },
        { name: t("footerSections.links.cookiePolicy"), path: "/cookies" },
        {
          name: t("footerSections.links.accessibility"),
          path: "/accessibility",
        },
        { name: t("footerSections.links.security"), path: "/security" },
        { name: t("footerSections.links.sitemap"), path: "/sitemap" },
      ],
    },
  ];

  const handleLinkClick = (path) => {
    window.location.href = path;
  };

  const handleSocialClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlePhoneClick = () => {
    window.open(`tel:${contactInfo.phone}`, "_self");
  };

  const handleEmailClick = () => {
    window.open(`mailto:${contactInfo.email}`, "_blank", "noopener,noreferrer");
   // window.location.href = `mailto:${contactInfo.email}`;
  };

  return (
    <footer className="w-full bg-[linear-gradient(134deg,#fbeed4_0%,#fbeed4_50%,#ffe6b9_100%)] rounded-t-[40px] pt-[20px] sm:pt-[30px] lg:pt-[40px] px-[20px] sm:px-[30px] lg:px-[40px] pb-[20px] sm:pb-[30px] lg:pb-[40px]">
      <div className="w-full max-w-[1182px] mx-auto">
        <div className="flex flex-col gap-[20px] sm:gap-[30px] lg:gap-[40px]">
          {/* Newsletter Section */}
          <div className="bg-global-text4 rounded-[16px] p-[16px] sm:p-[24px] lg:p-[32px]">
            <div className="flex flex-col lg:flex-row gap-[10px] sm:gap-[15px] lg:gap-[20px] items-start lg:items-center">
              <h3 className="text-[12px] sm:text-[18px] lg:text-[24px] font-svn-gilroy font-bold leading-[18px] sm:leading-[27px] lg:leading-[36px] text-global-text8 capitalize w-full lg:w-[34%]">
                {t("register_now")}
              </h3>
              <div className="bg-global-6 flex justify-center items-center rounded-[14px] p-[6px] sm:p-[9px] lg:p-[12px] flex flex-col sm:flex-row gap-[6px] sm:gap-[9px] lg:gap-[12px] w-full lg:flex-1">
                <input
                  type="email"
                  placeholder={t("emailPlaceholder")}
                  className="flex-1 bg-global-6 border border-global-text7 rounded-[8px] px-[14px] sm:px-[21px] lg:px-[28px] py-[7px] sm:py-[11px] lg:py-[14px] text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text7 focus:outline-none focus:ring-2 focus:ring-global-text4"
                />
                <Button
                  variant="primary"
                  onClick={() => {}} // Add required onClick prop
                className="bg-[#003459] text-white rounded-[8px] px-[15px] sm:px-[23px] lg:px-[30px] py-[7px] sm:py-[11px] lg:py-[14px] text-[12px] sm:text-[14px] lg:text-[16px] w-full sm:w-auto"
                >
                  {t("subscribe")}
                </Button>
              </div>
            </div>
          </div>

          {/* Footer Links */}
          <div className="border-b border-global-2 pb-[20px] sm:pb-[30px] lg:pb-[40px]">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
              <div className="flex flex-col sm:flex-row gap-[30px] sm:gap-[45px] lg:gap-[60px] mb-6 sm:mb-0">
                <span
                  className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors"
                  onClick={() => navigate("/")} // تحديث للتنقل إلى الصفحة الرئيسية
                >
                  {t("navigation.home")}
                </span>
                <span
                  className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors"
                  onClick={() => navigate("/product-listing")} // تحديث للتنقل إلى الفئات
                >
                  {t("navigation.categories")}
                </span>
                <button
                  onClick={() => navigate("/about-us")}
                  className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors"
                >
                  {t("navigation.aboutUs")}
                </button>
              </div>
              <div className="flex gap-[20px] sm:gap-[30px] lg:gap-[40px]">
                {/* تحديث الروابط الاجتماعية مع onClick للروابط الجديدة (احتفظت بـ img للتوافق، لكن أضفت تفاعل) */}
                <img
                  src="assets/images/facebook.svg"
                  className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                  alt="Facebook"
                  onClick={() => handleSocialClick(contactInfo.facebook)} // إضافة الرابط الجديد
                />
                {/* Twitter - احتفظ به كما هو إذا لم يكن هناك رابط جديد */}
                 <div
                className="flex items-center gap-[8px] cursor-pointer hover:text-global-text4 transition-colors"
                onClick={handleEmailClick}
              >
                <Icon
                  name="Email"
                  className="w-[16px] h-[16px] text-global-text4 flex-shrink-0"
                />{" "}
          
              </div>
                <img
                  src="assets/images/instagram.svg"
                  className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                  alt="Instagram"
                  onClick={() => handleSocialClick(contactInfo.instagram)} // إضافة الرابط الجديد
                />
                   {/* الهاتف */}
              <div
                className="flex items-center gap-[8px] cursor-pointer hover:text-global-text4 transition-colors"
                onClick={handlePhoneClick}
              >
                <Icon
                  name="Phone"
                  className="w-[16px] h-[16px] text-global-text4 flex-shrink-0"
                />{" "}
               
              </div>
              </div>
            </div>
          </div>

      

          {/* Footer Bottom */}
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <span className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text6 mb-4 sm:mb-0">
              {t("footerText")}
            </span>

            <div className="flex flex-col items-center gap-[2px] sm:gap-[3px] lg:gap-[4px] mb-4 sm:mb-0">
              <img
                src="assets/images/logo.png"
                className="w-[57px] sm:w-[86px] lg:w-[86px] h-[13px] sm:h-[20px] lg:h-[50px]"
                alt="Monito Logo"
              />
            </div>

            <span className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text6">
              {t("privacyProtected")}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
